import {
  Form,
  Radio,
  Input,
  Divider,
  Row,
  Col,
  Switch,
  ColorPicker,
} from 'antd';

import './style.scss';

import ColorPickerButton from '../../ColorPicker';

const DesignSettingsPanel = () => {
  return (
    <div className="design-settings-panel">
      <h6>Story Bar</h6>
      <Form.Item label="Video Feed View" name="videoFeedView">
        <Radio.Group size="large">
          <Radio.Button value="bar">Bar</Radio.Button>
          <Radio.Button value="grid">Grid</Radio.Button>
        </Radio.Group>
      </Form.Item>
      <Form.Item
        label="Video Feed Section Count (it must if selected grid view)"
        name="videoFeedSectionCount"
      >
        <Input size="large" placeholder="1, 2, 3" />
      </Form.Item>
      <Form.Item
        label="Video Feed Container Width (it must if selected grid view)"
        name={['props', 'storyPreviewWidth']}
      >
        <Input size="large" placeholder="pixel" />
      </Form.Item>
      <Form.Item label="View Layout" name="layout">
        <Radio.Group size="large">
          <Radio.Button value="classic">Classic</Radio.Button>
          <Radio.Button value="modern">Modern</Radio.Button>
        </Radio.Group>
      </Form.Item>
      <Form.Item label="Bar Layout" name="barLayout">
        <Radio.Group size="large">
          <Radio.Button value="classic">Classic</Radio.Button>
          <Radio.Button value="energized">Energized</Radio.Button>
        </Radio.Group>
      </Form.Item>
      <Form.Item label="Scroll Indicator" name={['props', 'scrollIndicator']}>
        <Radio.Group size="large">
          <Radio.Button value="off">Off</Radio.Button>
          <Radio.Button value="on">On</Radio.Button>
        </Radio.Group>
      </Form.Item>
      <Form.Item label="Alignment" name={['props', 'storyGroupAlign']}>
        <Radio.Group size="large">
          <Radio.Button value="left">Left</Radio.Button>
          <Radio.Button value="center">Center</Radio.Button>
          <Radio.Button value="right">Right</Radio.Button>
        </Radio.Group>
      </Form.Item>
      <Form.Item
        label="Distance between the story groups"
        name={['props', 'storyGroupMarginHorizontal']}
      >
        <Input size="large" placeholder="" />
      </Form.Item>
      <Divider />
      <h6>Story Group Cover</h6>
      <Row style={{ marginBottom: 24 }}>
        <Col span={24} style={{ marginBottom: 12 }}>
          <span>Unseen Color</span>
          <Form.Item noStyle shouldUpdate>
            {({ getFieldValue, setFieldValue }) => {
              const value = getFieldValue([
                'props',
                'storyGroupIconBorderColorNotSeen',
              ]);

              return (
                <ColorPickerButton
                  value={value}
                  onChange={(color) =>
                    setFieldValue(
                      ['props', 'storyGroupIconBorderColorNotSeen'],
                      color
                    )
                  }
                  title="Unseen color"
                />
              );
            }}
          </Form.Item>
          <Form.Item
            hidden
            name={['props', 'storyGroupIconBorderColorNotSeen']}
          >
            <ColorPicker />
          </Form.Item>
        </Col>
        <Col span={24}>
          <span>Seen Color</span>
          <Form.Item noStyle shouldUpdate>
            {({ getFieldValue, setFieldValue }) => {
              const value = getFieldValue([
                'props',
                'storyGroupIconBorderColorSeen',
              ]);

              return (
                <ColorPickerButton
                  value={value}
                  onChange={(color) =>
                    setFieldValue(
                      ['props', 'storyGroupIconBorderColorSeen'],
                      color
                    )
                  }
                  title="Unseen color"
                />
              );
            }}
          </Form.Item>
          <Form.Item hidden name={['props', 'storyGroupIconBorderColorSeen']}>
            <ColorPicker />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item label="Width" name={['props', 'storyGroupSizeWidth']}>
            <Input size="large" placeholder="" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Height" name={['props', 'storyGroupSizeHeight']}>
            <Input size="large" placeholder="" />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item
        label="Cover Border Size"
        name={['props', 'storyGroupBorderSize']}
      >
        <Input size="large" placeholder="" />
      </Form.Item>
      <Row gutter={16} align="middle">
        <Col flex="40px">
          <Form.Item
            noStyle
            dependencies={[['props', 'storyGroupBorderRadius']]}
          >
            {({ getFieldValue }) => {
              const borderRadius = getFieldValue([
                'props',
                'storyGroupBorderRadius',
              ]);
              return (
                <div
                  className="dynamic-border"
                  style={{
                    borderRadius: +borderRadius,
                  }}
                />
              );
            }}
          </Form.Item>
        </Col>
        <Col flex="auto">
          <Form.Item
            label="Border Radius"
            name={['props', 'storyGroupBorderRadius']}
          >
            <Input size="large" placeholder="" />
          </Form.Item>
        </Col>
      </Row>

      <Form.Item
        label="Border Gap Thickness"
        name={['props', 'storyBorderGapSize']}
      >
        <Input size="large" placeholder="" />
      </Form.Item>
      <Form.Item
        normalize={(value) => value.toHexString()}
        label="Border Gap Color"
        name={['props', 'storyBorderGapColor']}
      >
        <ColorPicker disabledAlpha showText />
      </Form.Item>
      <Divider />
      <h6>Story Group Title</h6>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            normalize={(value) => value.toHexString()}
            label="Unseen color"
            name={['props', 'storyGroupTextColor']}
          >
            <ColorPicker showText disabledAlpha />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            normalize={(value) => value.toHexString()}
            label="Seen color"
            name={['props', 'storyGroupTextSeenColor']}
          >
            <ColorPicker showText disabledAlpha />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item
        label="Text Visibility"
        name={['props', 'storyGroupTextVisibility']}
      >
        <Radio.Group size="large">
          <Radio.Button value={true}>On</Radio.Button>
          <Radio.Button value={false}>Off</Radio.Button>
        </Radio.Group>
      </Form.Item>
      <Form.Item label="Title Size" name={['props', 'storyGroupTextSize']}>
        <Input size="large" placeholder="" />
      </Form.Item>
      {/* <Form.Item label="Font" name={['props', 'storyGroupTextFont']}>
        <Input size="large" placeholder="" />
      </Form.Item> */}
      <Form.Item label="Text Weight" name={['props', 'storyGroupTextWeight']}>
        <Input size="large" placeholder="" />
      </Form.Item>
      <Form.Item
        label="Text Line Height"
        name={['props', 'storyGroupTextLineHeight']}
      >
        <Input size="large" placeholder="" />
      </Form.Item>
      <Form.Item
        label="Text Margin Top"
        name={['props', 'storyGroupTextMarginTop']}
      >
        <Input size="large" placeholder="" />
      </Form.Item>
      <Divider />
      <h6>Pin Icon</h6>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            normalize={(value) => value.toHexString()}
            label="Background Color"
            name={['props', 'storyGroupPinBackgroundColor']}
          >
            <ColorPicker showText disabledAlpha />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            normalize={(value) => value.toHexString()}
            label="Border Color"
            name={['props', 'storyGroupPinBorderColor']}
          >
            <ColorPicker showText disabledAlpha />
          </Form.Item>
        </Col>
      </Row>
      <Divider style={{ marginTop: 0 }} />
      <h6>Story Group Animation</h6>
      <Row justify="space-between" align="middle">
        <Col>
          <h6>Animation</h6>
        </Col>
        <Col>
          <Form.Item
            name={['props', 'storyGroupAnimation']}
            valuePropName="checked"
          >
            <Switch />
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
};

export default DesignSettingsPanel;
